import { Component, OnInit, ViewChild } from '@angular/core';
import { PaymentService } from '../services/payment/payment.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { Package } from '../models/package';
import { AccountService } from '../services/account/account.service';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { number } from '@amcharts/amcharts4/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-packages',
  templateUrl: './packages.component.html',
  styleUrls: ['./packages.component.css']
})
export class PackagesComponent implements OnInit {
  public paging = {currentPage:  0};
  // getSerialNumber(indexval) {
  //   return (this.paging.currentPage * 10 - 10) + indexval;
  // }

  addNewPackage = false;
  packageDetails: Package;
  packageDetailsList: any[];
  accounts: any[];
  selectedAccounts: any[];
  currencyList: any[];
  viewMode;
  fundusUnitPrice: number;
  fundusAutonomousUnitPrice: number;
  refractionUnitPrice: number;
  teleRefractionUnitPrice: number;
  referralUnitPrice: number;
  spectacleBasicUnitPrice: number;
  spectacleAdvancedUnitPrice: number;
  multiselectAIDropdownSettings;
  showRefractionModule;
  showReferralModule;
  showFundusModule;
  showSpectacleModule;
  packageGeneralFilter: boolean = false;
  packageAccountFilter: boolean = false;
  packageOfflineFilter: boolean = false;
  packageFilter: string = '';
  selectedPackageId: any;
  dropdownSettings: any = {};
  AIproviderList: any = [];
  selectedAIproviderIds: any;
  AIproviderUnits: number = 0;
  totalRecords: number = 0;
  rows = 10; // Rows per page
  
  // isRenewalLinkGenerated: boolean = false;
  // packageRenewalLink: any;
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  constructor(public foruscareService: ForuscareService, public paymentService: PaymentService, public accountService: AccountService) {
    this.packageDetails = new Package();
    this.multiselectAIDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };

    this.setupSearch();
    
  }

  ngOnInit() {
    this.getAvailableAccounts();
    this.currencyList = ["INR", "USD"];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  toggleDiv(type) {
    this.userSearchTerms = {
      term: "",
      searchby: ""
    }
    this.addNewPackage = !this.addNewPackage;
    if (type == "new") {
      this.packageDetails = new Package();
      this.getWorkFlowByAccountId(null);
      this.viewMode = "new";
    }
    if (type == "edit") {
      this.viewMode = "edit";
    }
  }

  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : this.packageDetails?.validity > 0 ?  event.charCode >= 48 && event.charCode <= 57 : event.charCode > 48 && event.charCode <= 57;
  }

  onPasteDaysNumber(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');

    // Check if the pasted text contains only numbers or a negative sign
    if (!/^\d+$/.test(pastedText) && !/^-?\d+$/.test(pastedText)) {
      // console.log("Invalid input. Only numbers are allowed.");
      return;
    }
    // Allow paste operation
    this.packageDetails.validity = +(`${this.packageDetails.validity}${pastedText}`);
  }

  //for multiselect
  onItemSelect() {
    this.getPaymentConfigData('selectedAccount');
    this.packageDetails.isAiPackageEnabled = false;
  }
  OnItemDeSelect() {
    this.getPaymentConfigData('deSelectedAccount');
    this.packageDetails.isAiPackageEnabled = false;
  }
  onSelectAll() {
    this.getPaymentConfigData('selectedAllAccount');
    this.packageDetails.isAiPackageEnabled = false;
  }
  onDeSelectAll() {
    this.getPaymentConfigData('deSelectedAllAccount');
    this.packageDetails.isAiPackageEnabled = false;
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              /* response.data.unshift({
                 name: 'Select Account',
                 id: 0,
                 disabled:true
               });*/

              for (var i = 0; i < response.data.length; i++) {
                this.accounts.push({ "id": response.data[i].accountId, "itemName": response.data[i].accountName });
              }
            }
            //this.accounts = response.data;
          }
           this.getPackageDetails(0, this.packageFilter);
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  savePackages(type) {
    if (this.packageDetails.pkgName == null || this.packageDetails.pkgName == "" || this.packageDetails.validity == null || this.packageDetails.price == null || this.packageDetails.currency == "" || this.packageDetails.currency == null || (this.packageDetails.isSpecific == true && (this.selectedAccounts == null || this.selectedAccounts.length == 0))) {
      this.foruscareService.showNotification("Enter all the mandatory fields", "danger");
      return;
    }

    if (this.packageDetails.price == null || this.packageDetails.price < 1) {
      this.foruscareService.showNotification("please enter valid package price.", "danger");
      return;
    }

    if (this.packageDetails.fundusUnit < 1 && this.packageDetails.teleRefractionUnit < 1 && this.packageDetails.refractionUnit < 1 && !this.packageDetails.isAiPackageEnabled) {
      this.foruscareService.showNotification("please enter valid service units, at least one service unit must me greater than one.", "danger");
      return;
    }

    if (this.packageDetails.isAiPackageEnabled && this.AIproviderUnits <= 0) {
      this.foruscareService.showNotification("please enter valid AI service units", "danger");
      return;
    }
    if (this.packageDetails.isAiPackageEnabled && this.selectedAIproviderIds == null || this.selectedAIproviderIds?.length < 1) {
      this.foruscareService.showNotification("please select at least one AI service provider", "danger");
      return;
    }
    if (this.packageDetails.isAiPackageEnabled && (this.packageDetails.category == null || this.packageDetails.category == "")) {
      this.foruscareService.showNotification("Please select AI category", "danger");
      return;
    }

    if (this.packageDetails.isAiPackageEnabled && this.selectedAIproviderIds !== null && this.AIproviderUnits > 0 || this.selectedAIproviderIds?.length > 0) {
      this.packageDetails.providerIds = this.selectedAIproviderIds.map(obj => obj.id);
      this.packageDetails.aiUnit = this.AIproviderUnits;
    }
    if(this.packageDetails.category === ''){
      this.packageDetails.category = null;
    }


    this.packageDetails.createdBy = 98;
    this.packageDetails.status = true;
    this.packageDetails.accountIds = [];
    if (this.selectedAccounts != null) {
      for (var i = 0; i < this.selectedAccounts.length; i++) {
        this.packageDetails.accountIds.push(this.selectedAccounts[i].id);
      }
    }
    let existingPackages = this.packageDetailsList?.filter(packageinfo => packageinfo.pkgName.trim().toLowerCase() == this.packageDetails.pkgName.trim().toLowerCase());
    if (type == "new") {
      if (existingPackages != null && existingPackages.length > 0) {
        this.foruscareService.showNotification("package already exits with same package name, please enter different name.", "danger");
        return;
      }
    }
    else {
      if (existingPackages != null && existingPackages.length > 1) {
        this.foruscareService.showNotification("package already exits with same package name, please enter different name.", "danger");
        return;
      }
    }

    if (type == "new") {
      this.paymentService.savePackageDetails(this.packageDetails)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification("Package saved successfully", "success");
            this.addNewPackage = false;
            this.getPackageDetails(0, this.packageFilter);
          }
          else if (response.errorCode == 409) {
            this.foruscareService.showNotification(response.message, "danger");
          } else {
            this.foruscareService.showNotification("Something went wrong! please try again later", "danger");
          }
        })
    }
    if (type == "edit") {
      this.paymentService.updatePackageDetails(this.packageDetails, this.packageDetails.id)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification("Package Saved successfully", "success");
            this.addNewPackage = false;
            this.getPackageDetails(0, this.packageFilter);
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        })
    }
  }

  onFilterChange(val) {
    this.packageDetailsList = [];
    this.getPackageDetails(0, this.packageFilter);
    // if (this.packageFilter == "") {
    //   this.getPackageDetails(0, this.packageFilter);
    // } else {
    //   this.getFilteredPackageDetails(this.packageFilter);
    // }
  }
  

  getFilteredPackageDetails(filterType) {
    this.selectedAccounts = null;
    this.paymentService.getPackageDetailsByFilter(filterType)
      .subscribe(response => {
        if (response.errorCode == 200 && response.data != null) {
          this.packageDetailsList = response.data;

          /*for(var i=0;i<this.packageDetailsList.length;i++){
            this.packageDetailsList[i].accountIds=[1,2,3];
          }*/
          for (var i = 0; i < this.packageDetailsList.length; i++) {
            if (this.packageDetailsList[i].accountIds.length > 0) {
              for (var j = 0; j < this.packageDetailsList[i].accountIds.length; j++) {
                for (var k = 0; k < this.accounts.length; k++) {
                  if (this.packageDetailsList[i].accountIds[j] == this.accounts[k].id) {
                    if (j == 0)
                      this.packageDetailsList[i].associatedAccounts = this.accounts[k].itemName;
                    else
                      this.packageDetailsList[i].associatedAccounts = this.packageDetailsList[i].associatedAccounts + "," + this.accounts[k].itemName;
                  }
                }
              }
            }
            if (this.packageDetailsList[i].isSpecific == false) {
              this.packageDetailsList[i].associatedAccounts = "Universal/General Package";
            }
          }

        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }
  offset = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first; 
    this.getPackageDetails(this.offset, this.packageFilter);

  }

  getPackageDetails(offset, packageType) {
    this.selectedAccounts = null;
    let count = 10;
    this.paymentService.getPackagesbyFilter(count, offset, this.userSearchTerms.term, this.userSearchTerms.searchby, packageType)
      .subscribe(response => {
        if (response.errorCode == 200 && response.data != null) {
          this.packageDetailsList = response.data.response;
          this.totalRecords = response.data.totalCount;
          /*for(var i=0;i<this.packageDetailsList.length;i++){
            this.packageDetailsList[i].accountIds=[1,2,3];
          }*/
          for (var i = 0; i < this.packageDetailsList.length; i++) {
            if (this.packageDetailsList[i].accountIds.length > 0) {
              for (var j = 0; j < this.packageDetailsList[i].accountIds.length; j++) {
                for (var k = 0; k < this.accounts.length; k++) {
                  if (this.packageDetailsList[i].accountIds[j] == this.accounts[k].id) {
                    if (j == 0)
                      this.packageDetailsList[i].associatedAccounts = this.accounts[k].itemName;
                    else
                      this.packageDetailsList[i].associatedAccounts = this.packageDetailsList[i].associatedAccounts + "," + this.accounts[k].itemName;
                  }
                }
              }
            }
            if (this.packageDetailsList[i].isSpecific == false) {
              this.packageDetailsList[i].associatedAccounts = "Universal/General Package";
            }
          }

        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }

  getPaymentConfigData(functionCallType) {
    if (this.selectedAccounts != null && this.selectedAccounts.length == 1) {
      this.paymentService.getPaymentConfig(this.selectedAccounts[0].id)
        .subscribe(response => {
          if (response.errorCode == 200 && response.data !== null) {
            if (response.data.fundus != null)
              this.fundusUnitPrice = response.data.fundus;
            if (response.data.fundusAutonomous != null)
              this.fundusAutonomousUnitPrice = response.data.fundusAutonomous;
            if (response.data.refraction != null)
              this.refractionUnitPrice = response.data.refraction;
            if (response.data.teleRefraction != null)
              this.teleRefractionUnitPrice = response.data.teleRefraction;
            if (response.data.referral != null) this.referralUnitPrice = response.data.referral;
            if (response.data.spectacleBasic != null)
              this.spectacleBasicUnitPrice = response.data.spectacleBasic;
            if (response.data.spectacleAdvanced != null)
              this.spectacleAdvancedUnitPrice = response.data.spectacleAdvanced;
            if (functionCallType != 'editPackage') {
              this.calculatePrice();
            }
            this.getWorkFlowByAccountId(this.selectedAccounts[0].id);
          }
          else {
            // this.foruscareService.showNotification("Something went wrong", "danger");
            this.getWorkFlowByAccountId(this.selectedAccounts[0].id);
            if (functionCallType != 'editPackage') {
              this.calculatePrice();
            }
          }
        })
    }
    else {
      if (functionCallType != 'editPackage') {
        this.calculatePrice();
      }
      this.resetWorkFlow();
    }
  }
  editPackageDetails(selectedPackage) {
    this.selectedAccounts = [];
    this.selectedAIproviderIds = [];
    this.selectedPackageId = selectedPackage.id;
    this.paymentService.getPackageDetailsById(selectedPackage.id)
      .subscribe(response => {
        if (response.errorCode == 200) {
          this.packageDetails = response.data;
          if (response.data.accountIds !== null && response.data.accountIds.length > 0) {
            for (var i = 0; i < response.data.accountIds.length; i++) {
              for (var j = 0; j < this.accounts.length; j++) {
                if (this.accounts[j].id == response.data.accountIds[i])
                  this.selectedAccounts.push({ "id": this.accounts[j].id, "itemName": this.accounts[j].itemName });
              }
            }
          }
          if (response.data.isAiPackageEnabled && response.data.aiPackages !== null && response.data.aiPackages.length > 0) {
            this.AIproviderUnits = response.data.aiUnit;
            let aiProviders = response.data.aiPackages;
            this.selectedAIproviderIds = aiProviders.map(pkg => ({
              id: pkg.providerId,
              name: pkg.providerName
            }));
            this.onAIpackageEnabled();
          }
          this.getPaymentConfigData('editPackage');
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
    //this.packageDetails=selectedPackage;
  }

  calculatePrice() {
    var totalPrice = 0;
    if (this.selectedAccounts != null && this.selectedAccounts.length == 1) {
      //this.paymentService.getPaymentConfig(this.selectedAccounts[0].id)
      //.subscribe(response=>{
      //if(response.errorCode==200){
      //if(response.data!=null){
      if (this.showFundusModule == true)
        totalPrice = this.fundusUnitPrice * this.packageDetails.fundusUnit;
      //totalPrice=totalPrice+this.fundusAutonomousUnitPrice*this.packageDetails.fundusAutonomousUnit;
      if (this.showRefractionModule == true) {
        totalPrice = totalPrice + this.refractionUnitPrice * this.packageDetails.refractionUnit;
        totalPrice = totalPrice + this.teleRefractionUnitPrice * this.packageDetails.teleRefractionUnit;
      }
      if (this.showReferralModule == true) { totalPrice = totalPrice + this.referralUnitPrice * this.packageDetails.referralUnit; }
      //totalPrice=totalPrice+this.spectacleBasicUnitPrice*this.packageDetails.spectacleBasicUnit;
      //totalPrice=totalPrice+this.spectacleAdvancedUnitPrice*this.packageDetails.spectacleAdvancedUnit;
      this.packageDetails.price = totalPrice;
      //}
      //else{
      //this.packageDetails.price=null;
      //}
      //}
      //})
      //this.getPaymentConfigData();
    }
    if (this.selectedAccounts == null || this.selectedAccounts.length > 1) {
      this.packageDetails.price = null;
      this.fundusUnitPrice = null;
      this.fundusAutonomousUnitPrice = null;
      this.refractionUnitPrice = null;
      this.teleRefractionUnitPrice = null;
      this.referralUnitPrice = null;
      this.spectacleBasicUnitPrice = null;
      this.spectacleAdvancedUnitPrice = null;
    }
  }

  onLastClick: any;
  changePackageStatus(selectedPackage) {
    clearTimeout(this.onLastClick);
    this.onLastClick = setTimeout(() => {
        //instead of sending whole package details for updating the status of the package , send package status and Id
        this.paymentService.updatePackageStatus(selectedPackage.status,selectedPackage.id)
       //this.paymentService.updatePackageDetails(selectedPackage, selectedPackage.id)
        .subscribe(response => {
          if (response.errorCode == 200) {
            this.foruscareService.showNotification("Package details updated successfully", "success");
          }

          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        });
    }, 0);
  }

  getWorkFlowByAccountId(accountId) {
    if (accountId == null) {
      this.showRefractionModule = true;
      this.showReferralModule = true;
      this.showFundusModule = true;
      this.showSpectacleModule = true;
      this.AIproviderUnits = 0;
      this.selectedAIproviderIds = null;
    }
    else {
      this.accountService.getAccountWorkflowByAccountId(accountId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null && response.data.length > 0) {
              response.data.forEach(data => {
                if (data.serviceName == "REFRACTION" && data.status == true) {
                  //data.draggable = false;
                  this.showRefractionModule = true;
                }
                else if (data.serviceName == "REFRACTION" && data.status == false) {
                  //data.draggable = false;
                  this.packageDetails.refractionUnit = 0;
                  this.packageDetails.teleRefractionUnit = 0;
                  this.showRefractionModule = false;
                }
                if (data.serviceName == "REFERRAL" && data.status == true) {
                  //data.draggable = false;
                  this.showReferralModule = true;
                }
                else if (data.serviceName == "REFERRAL" && data.status == false) {
                  //data.draggable = false;
                  this.showReferralModule = false;
                  this.packageDetails.referralUnit = 0;
                }
                if (data.serviceName == "FUNDUS" && data.status == true) {
                  //data.draggable = false;
                  this.showFundusModule = true;
                }
                else if (data.serviceName == "FUNDUS" && data.status == false) {
                  //data.draggable = false;
                  this.showFundusModule = false;
                  this.packageDetails.fundusUnit = 0;
                }
                if (data.serviceName == "SPECTACLE" && data.status == true) {
                  //data.draggable = false;
                  this.showSpectacleModule = true;
                }
                else if (data.serviceName == "SPECTACLE" && data.status == false) {
                  //data.draggable = false;
                  this.showSpectacleModule = false;
                  this.packageDetails.spectacleBasicUnit = 0;
                  this.packageDetails.spectacleAdvancedUnit = 0;
                }

                else {
                  data.draggable = true;
                }
              });
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }
  resetWorkFlow() {
    this.showRefractionModule = true;
    this.showReferralModule = true;
    this.showFundusModule = true;
    this.showSpectacleModule = true;
  }

  onAIpackageEnabled() {
    let selectedAccountIds = [];
    this.AIproviderList = [];
    // this.packageDetails.category = '';
    if (this.selectedAccounts?.length > 0 && this.packageDetails.isSpecific) {
      selectedAccountIds = this.selectedAccounts.map(obj => obj.id);
    }
    let payload = {
      "accountIds": selectedAccountIds,
      "type": "service_ai"
    }
    if (this.packageDetails.isAiPackageEnabled) {
      this.accountService.getAllServiceProvidersByFilter(payload).subscribe((res: any) => {
        if (res.data !== null && res.data.length > 0) {
          this.AIproviderList = res.data;
        } else {
          this.foruscareService.showNotification("No AI providers available for the selected account(s)", "danger");
          this.packageDetails.isAiPackageEnabled = false;
        }
      });
    }
  }

  // generatePackageRenewalLink() {
  //   this.accountService.getRenewalLinkforPackage(this.selectedPackageId).subscribe((res: any) => {
  //     if (res.data !== null && res.data.renewalRechargeLink !== null) {
  //       this.packageRenewalLink = res.data.renewalRechargeLink;
  //       this.isRenewalLinkGenerated = true;
  //     } else {
  //       this.isRenewalLinkGenerated = false;
  //       this.foruscareService.showNotification("Something went wrong! Please try again later.", "danger");
  //     }
  //   });
  // }

  // copyInviteLinkHandler() {
  //   let selBox = document.createElement('textarea');
  //   selBox.style.position = 'fixed';
  //   selBox.style.left = '0';
  //   selBox.style.top = '0';
  //   selBox.style.opacity = '0';
  //   selBox.value = this.packageRenewalLink;
  //   document.body.appendChild(selBox);
  //   selBox.focus();
  //   selBox.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(selBox);
  //   this.foruscareService.showNotification("Renewal link copied successfully", "success");
  // }

  
  setupSearch(): void {
    
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing
      distinctUntilChanged(),           // Only call the API if the term has changed
      switchMap((term: any) => this.paymentService.getPackagesbyFilter(0,this.offset,term[0],term[1],this.packageFilter))  // Switch to the new search term
    ).subscribe(response => {
        if (response.data != null && response.data.response.length > 0) {
          this.packageDetailsList = response.data.response;
          this.totalRecords = response.data.totalCount;
        }else{
          this.packageDetailsList = [];
        }
            // Update the results after the API call
    });
  }
  userSearchTerms = {
    term: '',
    searchby: ''
  }
  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    // if (this.table) {
    //   this.table.reset(); // Reset PrimeNG table
    // }
    this.offset = 0;
    this.packageDetailsList = [];
    this.paging.currentPage = 0;
    this.searchTerms.next([encodeURIComponent(term),searchby]);  // Push the search term into the observable stream
  this.userSearchTerms = {
    term: term,
    searchby: searchby
  }
  
  }
}

